document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.getElementById("mega-menu-scroll-items");
  const innerCircle = document.querySelector(".svg-bounce-inner-circle");
  const svgElement = document.querySelector(".svg-bounce-mega-menu");

  if (scrollContainer && innerCircle && svgElement) {
    scrollContainer.addEventListener("scroll", function () {
      if (scrollContainer.scrollTop > 0) {
        // When scrolled down, hide the elements and remove border-bottom
        innerCircle.style.height = "0";
        svgElement.style.height = "0";
        scrollContainer.style.borderBottom = "none";
      } else {
        // When scrolled back to the top, show the elements and restore border-bottom
        innerCircle.style.height = "35px"; // Original height
        svgElement.style.height = "20px";  // Original height
        scrollContainer.style.borderBottom = "1px solid #ccc"; // Change color if needed
      }

      // Smooth transitions for height changes
      innerCircle.style.transition = "height 0.5s ease-out";
      svgElement.style.transition = "height 0.5s ease-out";
    });
  }
});
